"use client";
import React from "react";
export default function StatsSection() {
  const cards = [
    {
      value: "256+",
      description: "Businesses Supported",
    },
    {
      value: "95%",
      description: "Customer Satisfaction",
    },
    {
      value: "45+",
      description: "Team Members",
    },
    {
      value: "100+",
      description: "Countries Served",
    },
  ];

  return (
    <section className="bg-black w-full py-[60px] px-4 min-[1340px]:px-0 flex flex-col items-center gap-12 overflow-hidden">
      {/* GRID */}
      <div className="max-w-[1200px] mx-auto w-full">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 max-sm:gap-2 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-[#0f1218] border border-white/10 rounded-[16px] p-4 md:p-8 flex flex-col gap-2"
            >
              <div className="text-[44px] font-bold uppercase text-white font-manrope">
                {card.value}
              </div>

              <p className="text-[12px] font-inter leading-[120%] text-white/70 font-medium">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
